import React, { useRef } from 'react'
import { useToggle, useOnClickOutside } from 'hooks'
import { ScrollableDirective } from 'components/Zui'
import './index.css'

function Index({ data, sliceBy }) {
    const { isOpen, onClose, onToggle } = useToggle()
    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, 'tagPills')
    return (
        <>
            <div className="tags-wrapper-l">
                <div className="tags-wrapper">
                    {data.length > 0 && (
                        <div className="tags-list-wrapper">
                            {data.slice(0, sliceBy).map(tag => {
                                return (
                                    <div key={tag} className="tag-item-wrapper">
                                        <span>{tag}</span>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    {data.length > sliceBy && (
                        <div className="multiple-tags-dropdown">
                            {isOpen && (
                                <div className="tags-drop-down-item-list" ref={myRef}>
                                    <ScrollableDirective
                                        style={{ maxHeight: '320px' }}
                                        theme="zbds-dark"
                                    >
                                        {data.slice(sliceBy).map(tag => {
                                            return (
                                                <div key={tag} className="tag-drop-down-item">
                                                    <span>{tag}</span>
                                                </div>
                                            )
                                        })}
                                    </ScrollableDirective>
                                </div>
                            )}
                            <div
                                className="tag-item-wrapper"
                                onClick={onToggle}
                                data-ref="tagPills"
                            >
                                <div className="multi-tag-wrapper" data-ref="tagPills">
                                    <span data-ref="tagPills">+{data.length - 3}</span>
                                    <div className="tags-open-icon" data-ref="tagPills">
                                        <zui-icon-arrows-arrow-outline-actually-centred-down
                                            size="s12"
                                            data-ref="tagPills"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {data.length && (
                <div className="tags-wrapper-sm">
                    <div className="multiple-tags-dropdown ">
                        {isOpen && (
                            <div className="tags-drop-down-item-list" ref={myRef}>
                                <ScrollableDirective
                                    style={{ maxHeight: '320px' }}
                                    theme="zbds-dark"
                                >
                                    {data.map(tag => {
                                        return (
                                            <div key={tag} className="tag-drop-down-item">
                                                <span>{tag}</span>
                                            </div>
                                        )
                                    })}
                                </ScrollableDirective>
                            </div>
                        )}
                        <div className="tag-item-wrapper" onClick={onToggle} data-ref="tagPills">
                            <div className="multi-tag-wrapper" data-ref="tagPills">
                                <span data-ref="tagPills">{data.length}</span>
                                <div className="tags-open-icon" data-ref="tagPills">
                                    <zui-icon-arrows-arrow-outline-actually-centred-down
                                        size="s12"
                                        data-ref="tagPills"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Index
